import React from 'react';
import { SELECTION_TABLE_COLUMN_ID } from "../../../hooks";
import { TableCheckbox } from "../../selection";
export const FilterHideColumns = props => {
  const {
    instance
  } = props;
  const {
    allColumns
  } = instance;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "font-size-14"
  }, "Afficher/masquer les colonnes"), /*#__PURE__*/React.createElement("hr", {
    className: "my-4"
  }), allColumns.map(column => {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: column.id
    }, column.Header && column.id !== SELECTION_TABLE_COLUMN_ID && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      className: "form-label"
    }, /*#__PURE__*/React.createElement(TableCheckbox, column.getToggleHiddenProps(), column.Header))));
  }));
};